import { Link } from "react-router-dom";

interface MovieCardProps {
  id: number;
  title: string;
  category: string;
  year: number;
  rating: number;
  imageUrl: string;
  showCategory?: boolean;
}

export default function MovieCard({ id, title, category, year, rating, imageUrl, showCategory = true }: MovieCardProps) {
  const categoryNames: Record<string, string> = {
    action: "动作",
    comedy: "喜剧",
    romance: "爱情",
    "sci-fi": "科幻",
    horror: "恐怖",
    animation: "动画",
    drama: "剧情",
    "tv-series": "电视剧",
  };

  return (
    <Link
      to={`/article/${id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/60 hover:border-accent-300/60 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[2/3] overflow-hidden bg-background-100">
        <img
          src={imageUrl}
          alt={title}
          title={title + " - 丁香花影院在线观看"}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
        <div className="absolute top-2 right-2 bg-background-50/90 backdrop-blur-sm text-accent-600 text-xs font-bold px-2 py-1 rounded-md whitespace-nowrap">
          {rating}
        </div>
        {showCategory && (
          <div className="absolute top-2 left-2 bg-background-50/90 backdrop-blur-sm text-foreground-700 text-xs px-2 py-1 rounded-md whitespace-nowrap">
            {categoryNames[category] || category}
          </div>
        )}
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-accent-600 transition-colors duration-200 line-clamp-1">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{year}</p>
      </div>
    </Link>
  );
}